import React, { useState,Fragment } from "react";
import propTypes from "prop-types";
import uuid from "uuid/v4";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  Button
} from "@material-ui/core";

import useStyles from "./stylesEnvios";

import TableActions from "../TableActions/TableActions";

// import { dataEnvios } from "../data";

const columns = [
  { id: "orden", label: "# de Orden", minWidth: 100 },
  { id: "rastreo", label: "Rastreo", minWidth: 100 },
  { id: "destinatario", label: "Destinatario", minWidth: 100 },
  { id: "destino", label: "Destino", minWidth: 100 },
  { id: "paqueteria", label: "Paquetería", minWidth: 100 },
  { id: "total", label: "Total", minWidth: 100 },
  { id: "acciones", label: "Acciones", minWidth: 100 }
];

const TableEnvio = ({ data = [] }) => {
  const rows = data;
  //console.log(rows);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = e => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Paper className={classes.tablePaper}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} aria-label="Tabla Envíos" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => (
                <TableRow key={uuid()}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="left">{row.numeroTracking}</TableCell>
                  <TableCell align="left">{row.destinatario}</TableCell>
                  <TableCell align="left">{row.destino}</TableCell>
                  <TableCell align="left">{row.paqueteria}</TableCell>
                  <TableCell align="left">
                    {Math.round(row.monto * 100) / 100}
                  </TableCell>
                  <TableCell align="left">
                    <a
                      href={row.label}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button variant="contained" color="primary">
                        Descargar
                      </Button>
                    </a>
                    {row.urlbillOfLading?(
                      <a
                      href={row.urlbillOfLading}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button variant="contained" color="secondary">
                        Carta Porte
                      </Button>
                    </a>
                    ):(<Fragment></Fragment>)}
                  </TableCell>
                </TableRow>
              ))}

            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                colSpan={7}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "Renglones por página" },
                  native: true
                }}
                labelRowsPerPage="Renglones por página"
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TableActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </Paper>
  );
};

TableEnvio.propTypes = {
  data: propTypes.array
};

export default TableEnvio;
